/** All tachograph tables offer the same page sizes. */
export const TACHOGRAPH_PAGE_SIZES = [10, 25, 50, 100, 1000];
